import { RefObject } from "react";

import { ReviewLogsDrawerControls } from "./ReviewLogsDrawerControls";
import { TracesDrawerControls } from "./TracesDrawerControls";
import useReset from "./hooks/useReset";

export const SearchBar = ({
  inputRef,
  requestsOn,
  onRefresh,
  onSearchActiveChange,
}: {
  inputRef: RefObject<HTMLInputElement | null>;
  requestsOn: boolean;
  onRefresh?: () => void;
  onSearchActiveChange?: (isActive: boolean) => void;
}) => {
  useReset(requestsOn);

  return (
    <div className="flex w-full items-center">
      {requestsOn ? (
        <ReviewLogsDrawerControls inputRef={inputRef} onRefresh={onRefresh} />
      ) : (
        <TracesDrawerControls
          inputRef={inputRef}
          onRefresh={onRefresh}
          onSearchActiveChange={onSearchActiveChange}
        />
      )}
    </div>
  );
};
